import { Button } from '@sortlist-frontend/design-system/legacy';
import { useTranslation } from '@sortlist-frontend/translation/ssr';

import { OPEN_FILTERS_DRAWER, RESET_FILTERS, useFiltersMessage } from '../Filters/FiltersBar';
import { NoResultsTemplate } from './NoResultsTemplate';

export const NoFilterResultsState = () => {
  const { t } = useTranslation();

  const { sendMessage } = useFiltersMessage();

  return (
    <NoResultsTemplate
      dataTestId="no-filter-results"
      title={t('longtail:agencyFilters.noResults.title')}
      subtitle={t('longtail:agencyFilters.noResults.subtitle')}
      primaryActions={
        <div className="flex flex-row items-center justify-center gap-x-2">
          <Button
            buttonStyle="secondary"
            buttonVariant="outlined"
            size="xxs"
            onClick={() => {
              sendMessage(RESET_FILTERS);
            }}>
            {t('longtail:agencyFilters.reset')}
          </Button>
          <Button
            buttonStyle="secondary"
            buttonVariant="light"
            size="xxs"
            onClick={() => {
              sendMessage(OPEN_FILTERS_DRAWER);
            }}>
            {t('longtail:agencyFilters.editFilters')}
          </Button>
        </div>
      }
    />
  );
};
